import { render, staticRenderFns } from "./jx3servers.vue?vue&type=template&id=1757bc74&"
import script from "./jx3servers.vue?vue&type=script&lang=js&"
export * from "./jx3servers.vue?vue&type=script&lang=js&"
import style0 from "./jx3servers.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports